$(document).ready(function() {
    // Rails CSRF setup for all AJAX requests
    // Was suggested to include this for Rails applications to prevent CSRF attacks
    $.ajaxSetup({
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
    });

    // Hide/Show client task in the modal (client email modal only)
    $(document).on('click', '.hide-task-btn', function() {
        const $li = $(this).closest('li.client-task-js');
        if (!$li.hasClass('task-hidden')) {
            $li.addClass('task-hidden');
            $(this).text('Show');
        } else {
            $li.removeClass('task-hidden');
            $(this).text('Hide');
        }
    });

    // Checkbox toggle for brand directors' note
    $(document).on('change', '.director-checkbox-js', function() {
        const targetId = $(this).data('target'); // this is the hidden input's id (uid)
        const show = $(this).is(':checked');

        $('#' + targetId).toggle(show);                         // hidden input
        $('#trix-toolbar-' + targetId).toggle(show);            // toolbar
        $('trix-editor[input="' + targetId + '"]').toggle(show); // editor
    });

    // Handle the click on the "Send Meeting Recap" button (opens the modal)
    $(document).on('click', '.clients-meetings-recap-component .send-recap-link', function() {
        const recapComponent = $('.clients-meetings-recap-component');
        const hsContactId = recapComponent.data('hs-contact-id');
        const modal = recapComponent.find('#notify-client-modal');
        const modalBody = modal.find('#client-recap-modal-body');

        // Show loading state in modal body
        modalBody.html('<em>Loading...</em>');
        modal.modal('show');

        // Fetch the modal body partial via AJAX
        $.get('/components/clients/meetings/recap/client_recap_modal_body', { hs_contact_id: hsContactId })
            .done(function(html) {
                modalBody.html(html);
                // Need to render the component for the resource list
                renderComponents()
            })
            .fail(function() {
                modalBody.html('<em>Error loading recap data.</em>');
            });
    });

    // Handle the click on the "Send to Client" button
    $(document).on('click', '.clients-meetings-recap-component .send-to-client-btn', function(e) {
        e.preventDefault(); // Prevent default form/button behavior

        const recapComponent = $('.clients-meetings-recap-component');
        const modal = $(this).closest('.modal');
        const hsContactId = recapComponent.data('hs-contact-id');

        // Meeting summary/note from the textarea
        const bodyText = modal.find('input[name="body_text"]').val();

        // Only include tasks NOT hidden
        const newClientTaskIds = modal
            .find('.new-client-tasks-js .client-task-js:not(.task-hidden)')
            .map((_, el) => $(el).data('client-task-id'))
            .get();

        const outstandingClientTaskIds = modal
            .find('.outstanding-client-tasks-js .client-task-js:not(.task-hidden)')
            .map((_, el) => $(el).data('client-task-id'))
            .get();

        const advisorClientTaskIds = modal
          .find('.new-advisor-tasks-js .client-task-js:not(.task-hidden)')
          .map((_, el) => $(el).data('client-task-id'))
          .get();

        // Extract resources
        const clientResourceIds = modal
            .find('.clients-meetings-resource-list-component .resource-item')
            .map((_, el) => $(el).data('client-resource-id'))
            .get()

        $.post(
            '/components/clients/meetings/recap/send_client_email',
            {
                hs_contact_id: hsContactId,
                body_text: bodyText,
                new_client_task_ids: newClientTaskIds,
                outstanding_client_task_ids: outstandingClientTaskIds,
                advisor_client_task_ids: advisorClientTaskIds,
                client_resource_ids: clientResourceIds
            }
        ).done(function(response) {
            recapComponent.find('#notify-client-modal').modal('hide');
        }).fail(function(xhr) {
            alert("There was an error sending the recap email.");
        });
    });

    // Handle "Skip Client" button
    $(document).on('click', '.clients-meetings-recap-component .skip-client-btn', function (e) {
        e.preventDefault();

        const recapComponent = $('.clients-meetings-recap-component');
        const firstModal  = recapComponent.find('#notify-client-modal');
        const secondModal = recapComponent.find('#notify-brand-directors-modal');

        // Close the client modal
        firstModal.modal('hide');

        // Load brand directors modal content
        const hs_contact_id = recapComponent.data('hs-contact-id');

        $.get(
            '/components/clients/meetings/recap/brand_recap_modal_body',
            { hs_contact_id: hs_contact_id }
        )
            .done(function (html) {
                $('#brand-recap-modal-body').html(html);
            })
            .fail(function () {
                $('#brand-recap-modal-body').html('<em>Error loading modal</em>');
            });

        // Open brand directors modal
        secondModal.modal('show');
    });

    // Handler for opening brand directors modal
    $(document).on('click', '.clients-meetings-recap-component .send-to-client-btn', function() {
        const recapComponent = $('.clients-meetings-recap-component');
        const firstModal = recapComponent.find('#notify-client-modal');
        const secondModal = recapComponent.find('#notify-brand-directors-modal');

        if (firstModal.length && secondModal.length) {
            firstModal.modal('hide'); // close first

            // Fetch and render brand directors
            const hs_contact_id = recapComponent.data('hs-contact-id');
            $.get('/components/clients/meetings/recap/brand_recap_modal_body', { hs_contact_id: hs_contact_id }).done(function(html) {
                $('#brand-recap-modal-body').html(html);
            }).fail(function() {
                $('#brand-recap-modal-body').html("<em>Error loading modal</em>");
            });
            secondModal.modal('show');
        }
    });

    // Handler for brand directors modal checkbox change (enable/disable submit button)
    $(document).on('change', '#notify-brand-directors-modal .director-checkbox-js', function() {
        const modal = $('#notify-brand-directors-modal');
        const anyChecked = modal.find('.director-checkbox-js:checked').length > 0;
        modal.find('.send-to-brand-directors-btn button[type="submit"], .send-to-brand-directors-btn input[type="submit"]').prop('disabled', !anyChecked);
    });

    // Disable the "Send to Brand Directors" button initially on modal show (resets state)
    $(document).on('shown.bs.modal', '#notify-brand-directors-modal', function() {
        const modal = $(this);
        modal.find('.send-to-brand-directors-btn button[type="submit"], .send-to-brand-directors-btn input[type="submit"]').prop('disabled', true);
    });

    // Handler for "Send to Brand Directors" button
    $(document).on('click', '.clients-meetings-recap-component .send-to-brand-directors-btn input[type="submit"]', function(e) {
        if ($(this).prop('disabled')) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }

        const recapComponent = $('.clients-meetings-recap-component');
        const modal = $(this).closest('.modal');
        const hsContactId = recapComponent.data('hs-contact-id');

        // Loop through each checked director checkbox and gather data
        const brandDirectorEmails = [];
        recapComponent.find('.director-checkbox-js:checked').each(function() {
            const $checkbox = $(this);
            const brandId = $checkbox.data('brand-id');
            const directorName = $checkbox.data('name');
            const directorFirstName = $checkbox.data('first-name');
            const directorEmail = $checkbox.data('email');
            const textareaId = $checkbox.data('target');
            const bodyText = $('#' + textareaId).val();
            brandDirectorEmails.push({
                brand_id: brandId,
                director_name: directorName,
                director_first_name: directorFirstName,
                director_email: directorEmail,
                body_text: bodyText
            });
        });

        // Gather tasks
        const clientTaskIds = modal
            .find('.client-tasks-js .client-task-js:not(.task-hidden)')
            .map((_, el) => $(el).data('client-task-id'))
            .get();

        $.post(
            '/components/clients/meetings/recap/send_brand_email',
            {
                hs_contact_id: hsContactId,
                brand_director_emails: brandDirectorEmails,
                client_task_ids: clientTaskIds,
            }
        ).done(function(response) {
            recapComponent.find('#notify-brand-directors-modal').modal('hide');
        }).fail(function(xhr) {
            alert("There was an error sending the brand director emails.");
        });
    });
});
